// WP6 Task 7 — WP1 route path → screen id (the vocabulary FAQ `screens` tags
// use, registry in @pageboss/shared/screen-ids). Pure string logic; ordered
// longest-pattern-first exactly like route-map's legacyRedirect. Unknown →
// null: the help panel falls back to its generic list rather than guessing.
import type { ScreenId } from '@pageboss/shared';

// T1.6A: a LOCATION screen names both ids — /app/b/{business}/l/{location}/…
const LOCATION_SCOPED: ReadonlyArray<[RegExp, ScreenId]> = [
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/foundation\/website\/pages\/[^/]+\/edit$/, 'page-edit'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/foundation\/website\/domain$/, 'domain'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/foundation\/website$/, 'website'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/foundation\/business-info$/, 'business-info'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/foundation\/mailboxes$/, 'mailboxes'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/foundation\/get-found-ready$/, 'get-found-ready'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/foundation$/, 'foundation'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/visibility\/google-profile\/content$/, 'gbp-content'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/visibility\/google-profile\/map$/, 'rank'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/visibility\/google-profile$/, 'gbp'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/visibility\/ai(?:\/[^/]+)?$/, 'ai-visibility'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/visibility\/aeo$/, 'aeo'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/visibility$/, 'visibility'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/reputation\/reviews$/, 'reviews'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/reputation\/settings$/, 'reputation-settings'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/reputation$/, 'reputation'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/pulse\/inbox$/, 'inbox'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/pulse\/leads$/, 'leads'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/pulse\/analytics$/, 'analytics'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/pulse$/, 'pulse'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/reports$/, 'reports'],
  [/^\/app\/b\/[^/]+\/l\/[^/]+\/overview$/, 'overview'],
];

// T1.6A: a BUSINESS screen names one id — /app/b/{business}/…
const BUSINESS_SCOPED: ReadonlyArray<[RegExp, ScreenId]> = [
  [/^\/app\/b\/[^/]+\/surveys(?:\/.*)?$/, 'surveys'],
  [/^\/app\/b\/[^/]+\/billing$/, 'billing'],
  [/^\/app\/b\/[^/]+\/locations$/, 'locations'],
  [/^\/app\/b\/[^/]+\/mailboxes$/, 'mailboxes'],
  [/^\/app\/b\/[^/]+\/settings$/, 'settings'],
  [/^\/app\/start$/, 'new-business'],
];

export function screenIdForPath(pathname: string): ScreenId | null {
  // Location patterns first: they are strictly longer, so a Business pattern
  // can never shadow one.
  for (const [re, id] of LOCATION_SCOPED) if (re.test(pathname)) return id;
  for (const [re, id] of BUSINESS_SCOPED) if (re.test(pathname)) return id;
  return null;
}
